import { render, staticRenderFns } from "./AttachmentMessage.vue?vue&type=template&id=aa00bd38&scoped=true&"
import script from "./AttachmentMessage.vue?vue&type=script&lang=ts&"
export * from "./AttachmentMessage.vue?vue&type=script&lang=ts&"
import style0 from "./AttachmentMessage.vue?vue&type=style&index=0&id=aa00bd38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa00bd38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCardText,VImg,VRow,VSpacer})
